export default __webpack_public_path__ + "b3876523438428741cb7a0e2ec0a80e5.svg";